import owd from 'owd/owd';

export default class Accordion extends owd.Component {
	init() {
		this.$item = this.$element.find('[data-accordion-item]');
		this.$button = this.$item.find('[data-accordion-button]');
		this.itemsOffsets = [];
		this.headerHeight = $('.header').outerHeight();

		this.bind();
	}

	calc() {
		this.$element.addClass('is-calculating');

		this.$item.each((i, obj) => {
			$(obj).prop('maxHeight', $(obj).outerHeight() + $(obj).find('[data-accordion-content]').outerHeight())
				  .prop('minHeight', $(obj).outerHeight())

			if ( $(obj).is('[data-accordion-item="initially-expanded"]') ) {
				$(obj).outerHeight($(obj).prop('maxHeight'));
			}
		});

		this.$element.removeClass('is-calculating');
	}


	bind() {

		this.on('domready ajaxload', this.dom.$window, () => {
			this.calc();

			this.$item.not('[data-accordion-item="initially-expanded"]').each((i, obj) => {
				$(obj).addClass('is-reduced')
					  .outerHeight($(obj).prop('minHeight'));
			})
		});


		//scroll to top
		// this.on('click', this.$item, (e) => {
		// 	let $target = $(e.currentTarget);
		// 	let index = $target.index();
		// 	let offset = $target.offset().top;
		//
        //     $('html,body').animate({
		// 		scrollTop: offset - this.headerHeight
		// 	}, 800, 'easeOutQuint');
		//
        // });



		this.on('click', this.$button, function () {
			var $ancestor = $(this).closest('[data-accordion-item]');

			if ($ancestor.hasClass('is-reduced')) {
				$ancestor.removeClass('is-reduced')
				.outerHeight($ancestor.prop('maxHeight'));
			} else {
				$ancestor.addClass('is-reduced')
				.outerHeight($ancestor.prop('minHeight'));
			}
		});

		this.on('resize-x', this.dom.$window, () => {
			this.$item.outerHeight('');
			this.calc();

			this.$element.find('.is-reduced').each((i, obj) => {
				$(obj).addClass('is-reduced')
					  .outerHeight($(obj).prop('minHeight'));
			})
		});
	}

	destroy() {
		super.destroy();
	}
}

owd.registerComponent('accordion', {
	component: Accordion
});
